import { Component } from '@angular/core';

@Component({
  selector: 'app-cards8-examples-49',
  templateUrl: './cards8-examples-49.component.html'
})
export class Cards8Examples49Component {}
